import { useTranslation } from 'react-i18next';
import type { PageType } from 'types';
import type { UpcomingProductsModule } from 'types/capi/modules';

import PopularReleasesCarousel from '~/components/PopularReleasesCarousel';
import Tracked from '~/components/Tracked';
import useRegion from '~/hooks/useRegion';

type Props = {
  items: UpcomingProductsModule['items'];
  pageType: PageType;
};

function ViewMoreButton() {
  const { t } = useTranslation('common');

  return (
    <div className="w-36">
      <Tracked.InternalLink
        variant="transparent-black-border"
        className="flex items-center justify-center"
        pagePosition="Homepage Upcoming Releases"
        name="VIEW_MORE"
        to={`/release-dates/?sort=UPCOMING_RELEASES`}
      >
        {t('viewMore')}
      </Tracked.InternalLink>
    </div>
  );
}

export default function UpcomingProducts({ items, pageType }: Props) {
  const region = useRegion();
  const { t } = useTranslation('home');

  const allowNotifications = region.code === 'GB';

  return (
    <div className="w-full bg-grey-tile">
      <div className="flex flex-col items-center justify-center gap-6 px-4 py-10 md:mx-auto md:max-w-desktop md:gap-8 md:px-0 md:py-20">
        {items && (
          <PopularReleasesCarousel
            products={items}
            title={t('upcomingReleases')}
            description={t('upcomingDescription')}
            showIcon={false}
            pagePosition="Homepage Upcoming Releases"
            pageType={pageType}
            allowNotifications={allowNotifications}
            showBackground={false}
            overrideInteractionPagePosition
          />
        )}
        <ViewMoreButton />
      </div>
    </div>
  );
}
